export const isNitroEnvironment = (): boolean =>
  window.location.hostname.includes('nitro.run');

export const isOrbitsEnvironment = (): boolean =>
  window.location.hostname.includes('orbits.run');

export const isShardTestEnvironment = (): boolean =>
  window.location.hostname.includes('shardtest');

const testingOrbitsEnvironmentPattern = /^\d{8}-\d{6}\.orbits\.run$/;

export const isTestingOrbitsEnvironment = (): boolean =>
  testingOrbitsEnvironmentPattern.test(window.location.hostname);

export const isNitroOrLocalEnvironment = (): boolean => {
  return isNitroEnvironment() || window.location.hostname.includes('localhost');
};
